window.adev = window.adev || {},
    function(o) {
        "use strict";
        window.adev.collection = {
            init() {
                this.collectionFilter()
            },
            collectionFilter() {
                o(document).on("click", "[data-sort-item-by]", function(t) {
                    var e, a;
                    992 < o(window).outerWidth() && (e = o(this).data("sort-item-by"), (a = new URL(window.location)).searchParams.set("sort_by", e), window.location.assign(a))
                }), o(document).on("change", "[data-facets-form]", function(t) {
                    992 < o(window).outerWidth() && o(this).trigger("submit")
                }), o(document).on("click", ".facets-wrapper-desktop .facet__item > .facet__open", function(t) {
                    var e = o(this).parent(".facet__item"),
                        a = e.find(".facet__dropdown"),
                        i = "-1" == a.attr("tabindex") ? "0" : "-1";
                    a.attr("tabindex", i), e.hasClass("active") ? e.removeClass("active") : (o(".facet__item.active").removeClass("active"), e.addClass("active"))
                }), o(document).on("click", function(t) {
                    var e = o(".facets-wrapper-desktop .facet__item"),
                        a = o(".facets-wrapper-desktop .facet__item.active");
                    e.is(t.target) || 0 !== e.has(t.target).length || (a.removeClass("active"), t = "-1" == (e = a.find(".facet__dropdown")).attr("tabindex") ? "0" : "-1", e.attr("tabindex", t))
                }), o(document).on("input paste", "[data-mobile-facets-form] input", function(t) {
                    t.preventDefault(), o("[data-mobile-facets-form]").trigger("change")
                }), o(document).on("change", "[data-mobile-facets-form]", function(t) {
                    t.preventDefault(), o("[data-mobile-facets-submit], [data-mobile-facets-reset]").prop("disabled", !1)
                }), o(document).on("click", "[data-mobile-facets-reset]", function(t) {
                    t.preventDefault(), o("[data-mobile-facets-form]").trigger("reset"), o("[data-mobile-facets-form]").find("[checked]").removeAttr("checked"), o("[data-mobile-facets-form]").find("[selected]").removeAttr("selected"), o("[data-mobile-facets-form]").find('input[type="number"]').val(""), o("[data-mobile-facets-form]").trigger("submit")
                }), o(document).on("click", "[data-mobile-facets-submit]", function(t) {
                    t.preventDefault(), o("[data-mobile-facets-form]").trigger("submit")
                }), o(document).on("click", ".facets-wrapper-mobile .facet__item > .facet__open", function(t) {
                    o(this).parent(".facet__item").toggleClass("active")
                })
            }
        }, window.adev.collection.init()
    }(jQuery);



if (!customElements.get('adev-collection-filter-btns')) {
    customElements.define('adev-collection-filter-btns', class adevCollectionFilterBtns extends HTMLElement {
        constructor() {
            super();
            this.observer = null;
        }

        connectedCallback() {
            this.setupIntersectionObserver();
        }

        disconnectedCallback() {
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }
        }

        setupIntersectionObserver() {
            const getStickyHeadersHeight = () => {
                let totalHeight = 0;
                
                // Add your header selector here
                const header = document.querySelector('.sticky-header-wrapper.sticky');
                if (header) {
                    totalHeight += header.offsetHeight;
                }
                
                // Add your announcement bar selector here
                const announcementBar = document.querySelector('[data-adev-notification-bar="true"]');
                if (announcementBar) {
                    totalHeight += announcementBar.offsetHeight;
                }
                
                return totalHeight;
            };

            const options = {
                root: null,
                rootMargin: `-${getStickyHeadersHeight()}px 0px 0px 0px`,
                threshold: 0
            };

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Element is in view
                        document.documentElement.classList.remove('has--scrolled-past-filter-btns');
                    } else {
                        // Element is scrolled past
                        document.documentElement.classList.add('has--scrolled-past-filter-btns');
                    }
                });
            }, options);

            this.observer.observe(this);
        }

    });
}


document.querySelectorAll('[data-adev-go-back-to-top="collection"]').forEach(button => {
    button.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});